








import { Vue, Component, Prop } from 'vue-property-decorator';

import InputField from './InputField.vue';
import SearchIcon from '../../icons/SearchIcon.vue';

@Component({
  components: {
    InputField,
    SearchIcon
  }
})
export default class SearchField extends Vue {
  @Prop(String) value!: string;
  @Prop(String) placeholder!: string;

  valueChanged(value: string) {
    this.$emit('change', value);
  }
}
